<template>
  <div class="insight-table">
    <table class="table table-hover mb-0">
      <thead class="bg-light">
        <tr>
          <th v-for="(header, index) in headers" :key="index" scope="col" class="border-0">
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
          <td v-for="(cell, cellIndex) in row" :key="cellIndex">
            {{ formatCell(cell) }}
          </td>
        </tr>
        <tr v-if="rows.length === 0">
          <td :colspan="headers.length" class="text-center text-muted py-4">
            No data available
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'InsightTable',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        headers: [],
        rows: [],
      }),
    },
  },
  computed: {
    headers() {
      return this.data.headers || [];
    },
    rows() {
      return this.data.rows || [];
    },
  },
  methods: {
    formatCell(cell) {
      if (cell === null || cell === undefined) {
        return '-';
      }
      if (typeof cell === 'number') {
        return cell.toLocaleString();
      }
      return cell;
    },
  },
};
</script>

<style scoped>
.insight-table {
  overflow-x: auto;
}
</style>

